<mat-form-field (resized)="calculatePanelWidth()" appearance="standard" class="search-form" [ngClass]="{ 'panel-open': panelOpen }">
  <mat-label translate>{{ label }}</mat-label>
  <input
    #input
    translate
    type="search"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    matAutocompletePosition="below"
    autocomplete="off"
  />
  <div matSuffix class="icon icon-name"></div>
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (closed)="handleClose()"
    (optionSelected)="handleOptionSelected($event)"
    [panelWidth]="length"
    (opened)="handleOpen()"
    [disableRipple]="true"
    [classList]="['search-panel-open']"
  >
    <mat-option *ngIf="loading; else resultsBlock" class="loading">
      <div class="loader-container">
        <div class="loader"></div>
      </div>
    </mat-option>
    <ng-template #resultsBlock>
      <mat-option *ngFor="let option of options" [value]="option" [ngClass]="option.companyId ? 'multiline-mat-option' : ''">
        <div class="multiline-company-name">
          {{ option.companyName || option }}
        </div>
        <div *ngIf="option.companyName" class="multiline-company-id">
          <small>
            {{ 'global.search.companyId' | translate }} {{ option.companyId }}
          </small>
        </div>
      </mat-option>
    </ng-template>
    <mat-option *ngIf="!loading && options" [value]="'cannotFindCompany'" class="italic">
      {{ "basicInfo.cannotFindCompany" | translate }}
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="error">
    {{ error }}
  </mat-error>
</mat-form-field>
